import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import RecommendContainer from '../../../features/page/post/recommend/RecommendContainer'

interface IProps {
    className?: string
}

const RecommendPage: React.FC<IProps> = ({className}) => {
    return (
        <PageLayout title={'Recommend Post'} className={className}>
            <RecommendContainer />
        </PageLayout>
    )
}

export default RecommendPage
